import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl } from '@angular/forms';
import { FieldErrorMessages } from '../../validators/field-error-messages';

@Component({
  selector: 'app-field-error',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="error-msg" *ngIf="control && control.invalid && (control.touched || control.dirty)">
      <span *ngFor="let err of getErrors()">{{ err }}</span>
    </div>
  `
})
export class FieldErrorComponent {
  @Input() control!: AbstractControl | null;
  @Input() type!: string;
  @Input() fieldName?: string;

  getErrors(): string[] {
    if (!this.control || !this.control.errors || !this.type) {
      return [];
    }

    const errors: string[] = [];
    const messageMap = FieldErrorMessages[this.type];

    if (!messageMap) {
      return [];
    }

    Object.keys(this.control.errors).forEach(key => {
      let msg = messageMap[key];
      if (msg) {
        if (this.fieldName) {
          msg = msg.replace('{fieldName}', this.fieldName);
        } else {
          msg = msg.replace('{fieldName}', 'This field');
        }
        // avoid duplicating messages if multiple error keys map to the same string (e.g. min/max -> invalid score)
        if (!errors.includes(msg)) {
          errors.push(msg);
        }
      }
    });

    return errors;
  }
}
